module.exports = __webpack_public_path__ + "img/body-model-arm-left.adcbce30.svg";